/*
 * @FilePath: index.js
 * @Author: 孙新宇
 * @Date: 2022-12-29 15:40:22
 * @LastEditTime: 2023-01-02 15:52:13
 * @Descripttion: 
 */
// import axios from "axios";

// axios.defaults.method = 'POST';
// axios.defaults.timeout = 10000;
// axios.defaults.baseURL = 'http://192.168.0.111:8888';
// axios.defaults.params = { dd_user_id: '260665095224157606' }


// export default {
//     suntae_axios(url, params) {
//         axios(url, params).then((response) => {
//             console.log(response.data)
//             return response.data;
//         })
//     }
// }

//-------------------------------------------------------------------
import axios from "axios";
import { Toast } from 'vant';

let user_id = '';

const api = axios.create({
    // http://192.168.0.111:8888
    // http://java-api.suntaeiv.com:8877
    baseURL: 'http://java-api.suntaeiv.com:8877', // 请求的公共地址部分
    timeout: 5000, // 请求超时时间 当请求时间超过5秒还未取得结果时 提示用户请求超时
    method: 'POST',
    params: { dd_user_id: user_id }
})

// interceptors axios的拦截器对象
api.interceptors.request.use(config => {
    // config 请求的信息

    // 如果user_id不是初始值,说明已经获取了数据,将新的user_id加入到params中
    if (user_id !== '') {
        config.params.dd_user_id = user_id
    }

    return config // 将配置完成的config对象返回出去 如果不返回 请求则不会进行
}, err => {
    // 请求发生错误时的处理 抛出错误
    Promise.reject(err)
})


api.interceptors.response.use(res => {
    // 我们一般在这里处理，请求成功后的错误状态码 例如状态码是500，404，403
    // res 是所有相应的信息
    console.log(res.data)
    return Promise.resolve(res.data)
}, error => {
    // 服务器响应发生错误时的处理
    // Promise.reject(err)
    if (error.response.status) {
        switch (error.response.status) {
            // 404请求不存在                
            case 404:
                Toast({
                    message: '网络请求不存在',
                    duration: 1500,
                    forbidClick: true
                });
                break;
            // 其他错误，直接抛出错误提示                
            default:
                Toast({
                    message: error.response.data.message,
                    duration: 1500,
                    forbidClick: true
                });
        }
        return Promise.reject(error.response);
    }
})


// 下面是详细的写法
export const suntae_axios = (url, params, header) => api({
    url: url, // 请求地址
    // data: params, // (一般post请求，我们习惯使用 data属性来传参)
    params: params, //(一般get请求，我们习惯使用params属性来传参）
    // 注意：data，和 params 两个属性传参使用，并不是固定的，也可以调换使用。
    header: header
})

// 用于获取userid 
export const queryUserInfo = (userid) => {

    return axios({
        method: 'POST',
        url: 'http://java-api.suntaeiv.com:8877/api/auth/get_user_id',
        params: userid
    }).then((response) => {
        console.log("response_________", response.data.result.userid);
        user_id = response.data.result.userid;

        Toast("登录成功");
        // localStorage.set("userStatus", 1)
    })



}